export const SET_NAME = 'SET_NAME';
export const SET_EMAIL = 'SET_EMAIL';
export const SET_COMPANY_NAME = 'SET_COMPANY_NAME';
export const SET_PASSWORD = 'SET_PASSWORD';
export const SUBMIT_SIGN_UP = 'SUBMIT_SIGN_UP';
export const SET_ERROR = 'SET_ERROR';
export const SET_VERIFICATION_CODE = 'SET_VERIFICATION_CODE';
export const CLEAR_SIGN_UP_INFO = 'CLEAR_SIGN_UP_INFO';